import {chain} from "../../utils/fs";

export const toCopayFormReq = (data, form) => {
    if(form){
        return chain(
            {},
            ...form.map((field) => (_) => {
                if (field.bypassField && data[field.bypassField]) {
                    return {
                        ..._,
                        [field.bypassField]: true,
                    };
                } else {
                    return {
                        ..._,
                        [field.path]: data[field.path],
                    };
                }
            }),
        );
    } else {
        return {};
    }
};
